import React from 'react';
import { NavLink } from 'react-router-dom';

const Navbar: React.FC = () => {
  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary border-bottom">
      <div className="container">
        <NavLink to="/" className="navbar-brand">
          MyApp
        </NavLink>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNavbar"
          aria-controls="mainNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse" id="mainNavbar">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink
                to="/"
                end
                className={({ isActive }) =>
                  `nav-link${isActive ? ' active' : ''}`
                }
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/login"
                className={({ isActive }) =>
                  `nav-link${isActive ? ' active' : ''}`
                }
              >
                Login
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  `nav-link${isActive ? ' active' : ''}`
                }
              >
                About
              </NavLink>
            </li>
            <li className="nav-item">
                <NavLink
                    to="/validation"
                    className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
                >
                    Validation
                </NavLink>
            </li>
          </ul>

          <div className="d-flex">
            <a
              className="btn btn-outline-primary"
              href="https://react.dev"
              target="_blank"
              rel="noreferrer"
            >
              Docs
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
